import { createSlice } from "@reduxjs/toolkit";

const btnsel=createSlice({
    name:"btnsel",
    initialState:{b:0},
    reducers:{
        setBtnselS:(state,action)=>{
            state.b=action.payload
        }
    }
});

export const {setBtnselS}=btnsel.actions
export default btnsel.reducer